export const appointmentStatusMeta = {
  booked: { label: "Booked", color: "#16a34a" },
  cancelled: { label: "Cancelled", color: "#dc2626" },
  attended: { label: "Attended", color: "#2563eb" },
  missed: { label: "Missed", color: "#64748b" },
  pending: { label: "Booked", color: "#16a34a" },
  confirmed: { label: "Booked", color: "#16a34a" },
  cancelled_by_client: { label: "Cancelled", color: "#dc2626" },
  cancelled_by_business: { label: "Cancelled", color: "#dc2626" },
  rescheduled: { label: "Booked", color: "#16a34a" },
  completed: { label: "Attended", color: "#2563eb" },
  no_show: { label: "Missed", color: "#64748b" },
};

export function formatDateTime(value, timezone) {
  if (!value) {
    return "--";
  }
  const dt = new Date(value);
  return dt.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: timezone || undefined,
  });
}

export function buildStatusBadgeStyle(status) {
  const meta = appointmentStatusMeta[status] || appointmentStatusMeta.booked;
  return {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: 999,
    background: `${meta.color}22`,
    color: meta.color,
    border: `1px solid ${meta.color}55`,
    padding: "2px 8px",
    fontSize: 12,
    fontWeight: 700,
  };
}

export function statusLabel(status) {
  return (appointmentStatusMeta[status] || appointmentStatusMeta.booked).label;
}
